export enum UserRight
{
  Undefined,
  User,
  Admin
}
